<template>
  <div
    data-column-filter
    data-dropdown-anchor
    :class="[$style.cell, config && $style.interactive]"
    @mouseenter="hovered = true"
    @mouseleave="hovered = false"
  >
    <div v-if="config" :class="$style.row">
      <SCAConditionFilter
        v-if="config.kind === 'text' || config.kind === 'number' || config.kind === 'date'"
        :col-key="colKey"
        :config="config"
        :model="model"
        :hovered="hovered"
        @model-change="emitModelChange"
      />
      <SCAListFilter
        v-else-if="config.kind === 'list'"
        :col-key="colKey"
        :config="config"
        :model="model"
        :hovered="hovered"
        @model-change="emitModelChange"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import SCAConditionFilter from "./condition/SCAConditionFilter.vue";
import type { ColFilterGroup } from "./filterModel";
import SCAListFilter from "./list/SCAListFilter.vue";
import type { ColumnFilterConfig } from "./types";

defineProps<{
  colKey: string;
  /** Null for a column type that cannot be filtered: the cell stays empty. */
  config: ColumnFilterConfig | null;
  model: ColFilterGroup[] | null;
}>();

const emit = defineEmits<{
  "model-change": [model: ColFilterGroup[] | null];
}>();

const hovered = ref(false);

function emitModelChange(model: ColFilterGroup[] | null) {
  emit("model-change", model);
}
</script>

<style module lang="scss">
.cell {
  width: 100%;
  height: 28px;
  overflow: hidden;
  contain: inline-size;
  padding: 0 8px;
  border-radius: var(--border-radius-large);
  box-shadow: inset 0 0 0 1px var(--color-border-default);
  transform: translateZ(0);
}

.interactive:hover {
  box-shadow: inset 0 0 0 1px var(--color-blue-p1);
}

.interactive:has(:focus-visible),
.interactive:has([data-popover-open]) {
  box-shadow: inset 0 0 0 2px var(--color-blue-p1);
}

.row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 28px;
  position: relative;
  cursor: pointer;
  color: var(--color-content-tertiary);
}
</style>
